import axios from 'axios';
import { URL } from '../tools/ApiRoutes';

/**
 * Convertir XML usando FormData
 * @param {string|File} xml - El contenido XML o archivo
 * @return {Promise} promise
 */
const convertXML = (xml) => {
    const formData = new FormData();

    if (xml instanceof File) {
        formData.append('file', xml);
    } else {
        const xmlBlob = new Blob([xml], { type: 'application/xml' });
        formData.append('file', xmlBlob, 'file.xml');
    }

    const headers = {
        'Content-Type': 'multipart/form-data',
    };

    return axios.post(`${URL}/facturas/parsexml`, formData, { headers })
        .then(({ data }) => {
            return data;
        });
};

/**
 * Parsear factura PDF usando FormData
 * @param {File} file - Archivo PDF de la factura
 * @return {Promise} promise
 */
const parseInvoice = (file) => {
    const formData = new FormData();

    if (file instanceof File) {
        formData.append('file', file);
    } else {
        throw new Error('Se requiere un archivo PDF valido');
    }

    const headers = {
        'Content-Type': 'multipart/form-data',
    };

    return axios.post(`${URL}/facturas/parse`, formData, { headers })
        .then(({ data }) => {
            return data;
        });
};

/**
 * Cambiar la factura base del proyecto cargando un XML
 * @param {File} file - Archivo XML de la factura
 * @return {Promise} promise
 */
const changeProjectInvoiceFile = (file) => {
    const formData = new FormData();

    if (file instanceof File) {
        formData.append('file', file);
    } else {
        throw new Error('Se requiere un archivo XML valido');
    }

    const headers = {
        'Content-Type': 'multipart/form-data',
    };

    return axios.post(`${URL}/facturas/cambiarFacturaProyecto`, formData, { headers })
        .then(({ data }) => {
            return data;
        });
};

/**
 * Asociar una factura existente a un proyecto
 * @param {number} idProjectD - Identificador del proyecto detalle
 * @param {number} idFactura - Identificador de la factura
 * @return {Promise} promise
 */
const changeProjectInvoice = (idProjectD, idFactura) => {
    const headers = {
        'Content-Type': 'application/json',
    };

    if (!idProjectD) {
        throw new Error('IdProjectD es requerido');
    }

    if (!idFactura) {
        throw new Error('IdFactura es requerido');
    }

    const data = {
        IdProjectD: idProjectD,
        IdFactura: idFactura
    };

    return axios.put(`${URL}/facturas/cambiarFacturaProyecto`, data, { headers })
        .then(({ data }) => {
            return data;
        });
};

export const invoicesService = {
    convertXML,
    parseInvoice,
    changeProjectInvoiceFile,
    changeProjectInvoice,
};
